import {createReducer} from '../utils';
import {
    SET_PAYEVER,
    SET_PENDING_ORDER,
    RESET_PAYEVER,
    FAILED_PAYEVER,
    SUCCESS_PAYEVER,
    PENDING_PAYEVER,
    CANCEL_PAYEVER,
    UNKNOWN_ERROR_PAYEVER,
    CHECK_PAYEVER,
    RESTART_PAYEVER,
    UNCHECK_PAYEVER,
    CHECKOUT_PAYEVER
} from '../constants';

const initialState = {
    id: 0,
    orderId: 0,
    generalError:false,
    performCheck: false,
    isSuccess: false,
    isPending: false,
    isError: false,
    isCancelled: false,
    rejected: false,
    processed: false,
    checkout: false,
    details: {},
    frame:''
};

export default createReducer(initialState, {
    [SET_PAYEVER]: (state, payload) => {
       return Object.assign({}, state, {
            id: payload.id,
            frame:payload.redirect_url
        });
    },
    [CHECKOUT_PAYEVER]: (state, payload) => {
       return Object.assign({}, state, {
            checkout: true
        });
    },
    [SET_PENDING_ORDER]: (state, payload) => {
       return Object.assign({}, state, {
            orderId: payload.data.orderId
        });
    },
    [CHECK_PAYEVER]: (state, payload) => {
       return Object.assign({}, state, {
           performCheck: true,
           frame:''
        });
    },
    [UNKNOWN_ERROR_PAYEVER]: (state, payload) => {
       return Object.assign({}, state, {
           generalError: true,
           frame:''
        });
    },
    [UNCHECK_PAYEVER]: (state, payload) => {
       return Object.assign({}, state, {
           performCheck: false
        });
    },
    [SUCCESS_PAYEVER]: (state, payload) => {
       return Object.assign({}, state, {
            isSuccess: true,
            isPending: false,
            isError: false,
            isCancelled: false,
            processed: true,
            details: payload
        });
    },
    [RESTART_PAYEVER]: (state, payload) => {
       return Object.assign({}, state, {
            isSuccess: false,
            isPending: false,
            isError: false,
            isCancelled: false,
            processed: false,
            rejected: false,
            details: {},
            frame:'',
            id: 0
        });
    },
    [CANCEL_PAYEVER]: (state, payload) => {
       return Object.assign({}, state, {
            isSuccess: false,
            isPending: false,
            isError: false,
            isCancelled: true,
            processed: true,
            rejected: true
        });
    },
    [PENDING_PAYEVER]: (state, payload) => {
       return Object.assign({}, state, {
            isSuccess: false,
            isPending: true,
            isError: false,
            isCancelled: false,
            rejected: false,
            details: payload
        });
    },
    [FAILED_PAYEVER]: (state, payload) => {
       return Object.assign({}, state, {
            id: 0,
            orderId: 0,
            isSuccess: false,
            isPending: false,
            isError: true,
            isCancelled: false,
            processed: true,
            rejected: true
        });
    },
    [RESET_PAYEVER]: (state, payload) => {
       return Object.assign({}, state, {
            id: 0,
            orderId: 0,
            isSuccess: false,
            generalError: false,
            isPending: false,
            isError: false,
            isCancelled: false,
            rejected: false,
            processed: false,
            checkout: false,
            details: {},
            frame:''
        });
    }
});



// WEBPACK FOOTER //
// ./src/reducers/payever.js